import { ITCFConsentStateAction } from "./types";

// generic dispatchAction function
export function dispatchTCFAction<Action extends ITCFConsentStateAction>(
  type: Action["type"],
  payload: Action["payload"],
  dispatch: (action: Action) => void
): void {
  dispatch({ type, payload } as Action);
}
